import {
    Button,
    HStack,
    Menu,
    MenuContent,
    MenuRadioGroup,
    MenuRadioItem,
    MenuTrigger,
    Tooltip
} from '@cad-arc';
import React, { useMemo } from 'react';
import { useLocationBias } from './use-location-bias';

export function LocationBiasMenu(): React.ReactElement {
    const locationBiasContext = useLocationBias();

    const { locationBiasFullName, formatedLocationBiasNameDisplay } = useMemo(() => {
        const fullName = `${locationBiasContext.locationBias?.label ?? 'None'}`;
        const formattedName = fullName.length > 15 ? `${fullName.substring(0, 12)}...` : fullName;

        return {
            locationBiasFullName: fullName,
            formatedLocationBiasNameDisplay: formattedName,
        };
    }, [locationBiasContext.locationBias?.label]);

    return (
        <Menu>
            <MenuTrigger>
                <Tooltip content={locationBiasFullName}>
                    <Button variant="ghost" data-testid="location-bias">
                        Location Bias: {formatedLocationBiasNameDisplay}
                    </Button>
                </Tooltip>
            </MenuTrigger>
            <MenuContent avoidCollisions style={{ overflowY: 'auto', maxHeight: '600px' }}>
                <HStack justify="flex-end">
                    <Button
                        isDisabled={!locationBiasContext?.locationBias}
                        variant="ghost"
                        size="sm"
                        data-testid="location-bias-clear-button"
                        onClick={() => {
                            locationBiasContext.setLocationBiasId?.(undefined);
                        }}
                    >
                        Clear D-Area
                    </Button>
                </HStack>
                <MenuRadioGroup
                    value={locationBiasContext.locationBias?.value.toString()}
                    onValueChange={(value) => {
                        const isDifferentLocationBias =
                            value !== locationBiasContext.locationBias?.value.toString();

                        if (!isDifferentLocationBias) {
                            return;
                        }

                        const selectedLocationBiasId = value ? parseInt(value, 10) : undefined;
                        locationBiasContext.setLocationBiasId?.(selectedLocationBiasId);
                    }}
                >
                    {locationBiasContext.dispatchAreaOptions.map((dispatchAreaOption) => (
                        <MenuRadioItem
                            key={dispatchAreaOption.value}
                            value={dispatchAreaOption.value.toString()}
                        >
                            {dispatchAreaOption.label}
                        </MenuRadioItem>
                    ))}
                </MenuRadioGroup>
            </MenuContent>
        </Menu>
    );
}
